import { useState } from 'react';

export * from './Modal';

export const closeHook = () => {
  const [signal, setSignal] = useState();
  const trigger = () => {
    console.log('set signal true', signal);
    setSignal(true);
    setTimeout(() => setSignal(false), 10);
  };
  return { trigger, signal };
};
